import { render, staticRenderFns } from "./Boss.vue?vue&type=template&id=64d6f1a2&scoped=true&"
import script from "./Boss.vue?vue&type=script&lang=js&"
export * from "./Boss.vue?vue&type=script&lang=js&"
import style0 from "./Boss.vue?vue&type=style&index=0&id=64d6f1a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6f1a2",
  null
  
)

export default component.exports